import { Crm9ProfileForm } from "@/components/crm-demos/crm-9-profile-form"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/crm-9")({
  component: Crm9Page,
  head: () => ({ meta: [{ title: "CRM 9 · Profile Form" }] }),
});

function Crm9Page() {
  return <Crm9ProfileForm />
}
